<template>
  <el-dialog
    :visible.sync="visible"
    modal-append-to-body
    append-to-body
    :close-on-click-modal="false"
    width="1250px"
  >
    <template slot="title">
      <div style="display:flex;align-items:center;">
        <span>{{ siteDevice.name }}-{{ dataTime }}-{{ factor.name }}</span>
        <SelectCtrlGroup
          :ids="selectedDataTimes"
          :options="Object.values(minuteDataMap)"
          idProp="dataTime"
          @change="onSelectCtrlChange"
        />
      </div>
    </template>
    <div v-if="dataTimes.length > 0" class="minutes-wrapper">
      <el-checkbox-group v-model="selectedDataTimes" class="minute-select-group">
        <el-checkbox
          v-for="(minuteTime, index) in dataTimes"
          :key="index"
          :disabled="!minuteDataMap[minuteTime]"
          :label="minuteDataMap[minuteTime] && minuteDataMap[minuteTime].dataTime"
          @change="onSelectedMinutesChange(minuteDataMap[minuteTime], ...arguments)"
        >
          <span class="minute-data-detail"><span>{{ minuteTime }}</span><span><span>{{ minuteDataMap[minuteTime] ? minuteDataMap[minuteTime].value : '--' }}</span> {{ minuteDataMap[minuteTime] ? minuteDataMap[minuteTime].flag : '' }}</span></span>
        </el-checkbox>
      </el-checkbox-group>

      <div style="height:250px;padding-top:20px;">
        <e-chart ref="chart" @initialized="onChartInitialized" @destroy="onChartDestroy" />
      </div>
    </div>

    <template slot="footer">
      <div class="dialog-footer">
        <el-button type="orange" @click="onRegenBtnClick" style="margin-right: 5px;">重新生成小时数据</el-button>
        <el-button type="info" @click="onRecoverBtnClick" style="margin-right: 5px;">恢复小时数据</el-button>
        <el-button @click="onCloseBtnClick" style="margin-right: 5px;">关闭</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import BaseStore from '../../../components/BaseStore'
import unitConverter from '../../../utils/unitConverter'
import { PROCESS_PANEL_SAVE } from './EventKeys'

export default {
  name: 'RegenHourDataDialog',
  extends: BaseStore,
  props: {
    site: {
      required: true,
      type: Object
    },
    siteDevice: {
      required: true,
      type: Object
    },
    defaultUnitProp: {
      type: String,
      default: 'displayUnit'
    }
  },
  data () {
    return {
      visible: false,
      dataTime: '',
      factorId: '',
      minuteDataMap: Object.freeze({}),
      unitProp: this.defaultUnitProp,
      selectedDataTimes: []
    }
  },
  computed: {
    factor () {
      return this.factorMap[this.factorId] || {name: ''}
    },
    dataTimes () {
      const {dataTime} = this
      const dataTimes = []
      if (dataTime) {
        let beginTS = new Date(`${dataTime}:00:00`).getTime()
        const endTS = new Date(`${dataTime}:59:59`).getTime()
        for (; beginTS <= endTS; beginTS += 60000) {
          dataTimes.push(new Date(beginTS).format('HH:mm'))
        }
      }

      return dataTimes
    }
  },
  methods: {
    setChartOption (dataList) {
      const { factor } = this

      const chartOption = {
        dataset: {
          source: dataList
        },
        grid: {
          top: 30,
          right: 20,
          bottom: 10,
          left: 20,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          interval: 1,
          axisLabel: {
            formatter: dataTime => new Date(dataTime).format('mm')
          },
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          name: factor[this.unitProp]
        },
        tooltip: {
          appendToBody: true
        },
        series: {
          type: 'line',
          name: factor.name,
          smooth: true,
          symbol: (data) => data.isUse ? 'circle' : 'emptyCircle',
          symbolSize: 8,
          encode: {
            x: 'dataTime',
            y: 'value',
            tooltip: ['value', 'flag']
          }
        }
      }

      const { chart } = this.$refs
      chart.clear()
      chart.resize()
      chart.setOpt(chartOption)
    },
    onValueClick (dataTime, factorId) {
      const formatDataTime = dataTime.replace(/-/g, '/')
      this.$api.Data.getRealTimeData({
        beginTime: `${formatDataTime}:00:00`,
        endTime: `${formatDataTime}:59:59`,
        siteId: this.site.id,
        factorIds: [factorId]
      }).then((dataList) => {
        this.dataTime = formatDataTime
        this.factorId = factorId
        const {factor} = this
        const {stdUnit, molecular, decimalNum} = factor
        const dispUnit = factor[this.unitProp]
        this.minuteDataMap = Object.freeze(dataList.reduce((map, data) => {
          data.value = Number(unitConverter(data.value, stdUnit, dispUnit, molecular).toFixed(decimalNum))
          map[new Date(data.dataTime).format('HH:mm')] = data
          return map
        }, {}))
        this.selectedDataTimes = dataList.reduce((list, data) => {
          if (data.isUse) {
            list.push(data.dataTime)
          }

          return list
        }, [])
        this.visible = true

        setTimeout(() => {
          this.setChartOption(dataList)
        }, 0)
      }).catch(console.error).finally(() => {
        dataTime = null
        this.changeLoadStatus(false)
      })
    },
    onSelectedMinutesChange (data, checked) {
      data.isUse = checked
      this.$refs.chart.setOpt({
        dataset: {
          source: Object.values(this.minuteDataMap)
        }
      }, true)
    },
    onSelectCtrlChange () {
      const selectedMap = this.selectedDataTimes.reduce((map, dataTime) => {
        map[dataTime] = true
        return map
      }, {})
      const minuteDataList = Object.values(this.minuteDataMap)
      minuteDataList.forEach(data => {
        data.isUse = !!selectedMap[data.dataTime]
      })
      this.$refs.chart.setOpt({
        dataset: {
          source: Object.values(this.minuteDataMap)
        }
      }, true)
    },
    onUnitPropChanged (unitProp) {
      this.unitProp = unitProp
    },
    onRegenBtnClick () {
      this.changeLoadStatus(true)
      this.$api.Audit.reGenHourData({
        factorId: this.factorId,
        siteDeviceId: this.siteDevice.id,
        dataTimes: this.selectedDataTimes
      }).then(() => {
        this.visible = false
        this.$eventBus.emit(PROCESS_PANEL_SAVE)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onRecoverBtnClick () {
      this.changeLoadStatus(true)
      this.$api.Audit.restoreHourData({
        dataTime: `${this.dataTime}:00:00`,
        factorId: this.factorId,
        siteDeviceId: this.siteDevice.id
      }).then(data => {
        this.visible = false
        this.$eventBus.emit(PROCESS_PANEL_SAVE)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onCloseBtnClick () {
      this.visible = false
    },
    onChartClick (param) {
      const { data } = param
      const { dataTime } = data
      const { selectedDataTimes, minuteDataMap } = this
      const oData = minuteDataMap[new Date(dataTime).format('HH:mm')]
      const { isUse } = oData
      oData.isUse = !isUse

      if (isUse) {
        const index = selectedDataTimes.indexOf(dataTime)
        if (index > -1) {
          selectedDataTimes.splice(index, 1)
        }
      } else {
        selectedDataTimes.push(dataTime)
      }

      this.$refs.chart.setOpt({
        dataset: {
          source: Object.values(minuteDataMap)
        }
      }, true)
    },
    onChartInitialized (chart) {
      chart.on('click', this.onChartClick)
    },
    onChartDestroy (chart) {
      chart.off('click', this.onChartClick)
    }
  },
  created () {
    this.$eventBus.on('onValueClick', this.onValueClick)
    this.$eventBus.on('setCurrentUnitKey', this.onUnitPropChanged)
  },
  beforeDestroy () {
    this.$eventBus.off('onValueClick', this.onValueClick)
    this.$eventBus.on('setCurrentUnitKey', this.onUnitPropChanged)
  }
}
</script>

<style lang="scss" scoped>
.minute-select-group {
  display: grid;
  grid-template-columns: repeat(4, max-content);
  justify-content: space-between;
  padding: 0 20px;

  .minute-data-detail {
    display: grid;
    grid-template-columns: 1fr max-content max-content;

    > :nth-child(2) {
      margin-left: 15px;

      > :first-child {
        color: red;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/RegenHourDataDialog.vue